import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Chip, FormControl, Typography } from '@mui/material'
import { Autocomplete } from '@mui/material'
import { TextField } from '@mui/material'
import { titleCase } from 'src/helpers/functions'
import { createFilterOptions } from '@mui/material'
const SingleCustomAutocomplete = (props) => {
  const fieldName = props.fieldName
  const fieldLabel = props.label
  const list = props.list
  const fieldValue = props.value
  const listKey = props.listKey
  const listDescription = props.description
  const customOnChange = props.customOnChange
  const rowSize = props.rowSize
  const [currValue, setCurrValue] = useState(null)

  const optionForLabel = (label) => {
    if (typeof label === 'object' && !Array.isArray(label) && label !== null) {
      return label[listDescription]
    }
    let toReturn = list.find((source) => {
      return source[listKey] == label
    })
    if (toReturn) {
      return toReturn[listDescription]
    }
    return `${label}`
  }

  const update = (event, value) => {
    if (value === null) {
      setCurrValue(null)
      if (customOnChange) {
        customOnChange(null, fieldName, event)
      }
      return
      // }else if( typeof value === 'string'){
      //     setValue(optionForLabel(value))
    } else {
      setCurrValue(value[listKey])
      if (customOnChange) {
        customOnChange(value[listKey], fieldName, value[listDescription], event)
      }
    }
  }
  const filterOptions = createFilterOptions({
    stringify: (option) => option[listDescription],

    matchFrom: 'any',
  })

  // const filterOptions = createFilterOptions()

  return (
    <FormControl style={{ width: '100%' }}>
      <Autocomplete
        disabled={props.disabled ? props.disabled : false}
        name={titleCase(fieldName)}
        options={list} // Options List
        value={
          customOnChange ? (props.hasOwnProperty('value') ? fieldValue : currValue) : currValue
        }
        // inputValue=""
        onChange={update}
        getOptionLabel={optionForLabel}
        isOptionEqualToValue={(option, value) => {
          return value == option[listKey]
        }}
        style={{ width: '100%' }}
        renderInput={(params) => (
          <TextField
            {...params}
            label={fieldLabel}
            variant="standard"
            InputProps={{
              ...params.InputProps,
              // startAdornment: fieldValue ? (
              //   <Chip
              //     label={list.find((x) => x[listKey] == fieldValue)[listDescription]}
              //     style={{
              //       backgroundColor: '#e0e0e0',
              //     }}
              //   />
              // ) : null,

              style: {
                fontSize: rowSize ? '13px' : '',
                backgroundColor: list?.find((x) => x[listKey] == fieldValue)?.color,

                paddingRight: rowSize ? 0 : '',
              },
            }}
            sx={{
              '& .MuiInputLabel-root': {
                fontSize: rowSize ? '13px' : '',
              },

              '& .MuiAutocomplete-inputRoot[class*="MuiInput-root"] .MuiAutocomplete-input': {
                textAlign: rowSize ? 'center' : '',
              },
            }}
          />
        )}
        filterOptions={(options, state) => {
          const filtered = filterOptions(options, state)

          const input = state.inputValue.toLowerCase()

          const filteredOptions = filtered.sort((a, b) => {
            const labelA = a[listDescription].toLowerCase()
            const labelB = b[listDescription].toLowerCase()

            const containsInput = (label) => label.includes(input)
            const startsWithInput = (label) => label.startsWith(input)

            // Prioritize items that start with the input, then items that contain the input
            if (startsWithInput(labelA) && !startsWithInput(labelB)) return -1
            if (!startsWithInput(labelA) && startsWithInput(labelB)) return 1
            if (containsInput(labelA) && !containsInput(labelB)) return -1
            if (!containsInput(labelA) && containsInput(labelB)) return 1
            return 0
          })

          return filteredOptions
        }}
        // filterOptions={(options, params) => {
        //   const filtered = filterOptions(options, params)
        //   return filtered
        // }}

        renderOption={(props, option) => {
          return (
            <li {...props} key={option[listKey]}>
              <Typography
                style={{
                  fontSize: rowSize ? '13px' : '',
                  backgroundColor: option['color'] ? option['color'] : '',
                  padding: option['color'] ? '0px 12px 0px 12px' : '',
                  height: option['color'] ? '32px' : '',
                  borderRadius: option['color'] ? '16px' : '',
                  alignContent: 'center',
                }}
              >
                {option[listDescription]}
              </Typography>
            </li>
          )
        }}
      />
      {currValue && <input type="hidden" name={fieldName} value={currValue} />}
    </FormControl>
  )
}

SingleCustomAutocomplete.propTypes = {
  fieldName: PropTypes.any.isRequired,
  label: PropTypes.any.isRequired,
  list: PropTypes.any.isRequired,
  value: PropTypes.any,
  listKey: PropTypes.any.isRequired,
  description: PropTypes.any.isRequired,
  customOnChange: PropTypes.any,
  disabled: PropTypes.any,
  rowSize: PropTypes.any,
}

export default SingleCustomAutocomplete
